import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const COOKIE_CONSENT_KEY = "barton_cookie_consent";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice this session
    const consent = sessionStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay to prevent flash on page load
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    sessionStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fade-in-up"
    >
      <div className="container-custom">
        <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 md:p-8 shadow-2xl max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            {/* Content */}
            <div className="flex-1">
              <h3 className="font-heading text-lg font-bold text-white mb-2">
                We use cookies
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                We use cookies to improve your experience on our site. By continuing to browse, you agree to our use of cookies. 
                Learn more in our{" "}
                <Link 
                  to="/privacy-policy" 
                  className="text-pink-400 hover:underline"
                >
                  Privacy Policy
                </Link>.
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <Button
                onClick={handleDecline}
                variant="outline"
                data-testid="cookie-decline-btn"
                className="rounded-full px-6 border-white/20 text-white hover:bg-white/10 bg-transparent"
              >
                Decline
              </Button>
              <Button
                onClick={handleAccept}
                data-testid="cookie-accept-btn"
                className="bg-gradient-to-r from-purple-500 to-pink-500 hover:bg-gradient-to-r from-purple-500 to-pink-500/90 text-white rounded-full px-6"
              >
                Accept All
              </Button>
            </div>

            {/* Close button */}
            <button
              onClick={handleDecline}
              className="absolute top-4 right-4 md:hidden p-2 text-white/40 hover:text-white transition-colors"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
